import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/Model/User/user.model';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
  currentUser:User;

  username;
  branch;
role;
success;
  error;
  loggedInUsername
  loggedInUserBranch;
  loggedInUserFullname;
  loggedInUserId;
  constructor(
    private router: Router, 
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService,) { 

      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
        this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
        this.branch=this.currentUser.branch;
        this.role=this.currentUser.role;
        this.loggedInUserId=this.currentUser.userName;

  
        this.loggedInUserFullname= this.username;
        this.loggedInUserBranch= this.branch
        this.loggedInUserId=this.currentUser.userName;
    
        
    
       }
  }

  ngOnInit(): void {
    this.logout();
  }




  logout() {
    this._authenticationService.logout(this.loggedInUserId);
    this.router.navigate(['/login']);
}

}
